import "babel-polyfill";
import "array-flat-polyfill";
import "./core/owl.carousel.min.js";
import "./core/theme.js";
import "../styles/theme.scss";
import "./product-parent.js";
import "./product-page.js";
import "./zeynep.js";
import "./loyalty.js";

console.log('v3')

    /**
    * applySwatches: 
    * @param  {[type]} swatches         array of swatch elements with data-value='[Color Name]'
    * @param  {[type]} applyToSelector  query of child elements to apply background to
    */
    window.applySwatches = function(swatches, applyToSelector) {
    swatches.each(function(index, swatch) {
        
        var swatchColorAttribute = swatch.dataset.value;
        var swatchColors = swatchColorAttribute.split(' & ');

        var swatchHexes = swatchColors.map(function(name) {
        return colors[name] || '#000';
        });

        var bg;

        if (swatchHexes.length === 1) {
        bg = swatchHexes[0];
        } else if (swatchHexes.length === 2) {
        bg = `linear-gradient(135deg, ${swatchHexes[0]} 50%, ${swatchHexes[1]} 50%)`;
        } else if (swatchHexes.length === 3) {
        bg = `linear-gradient(135deg, ${swatchHexes[0]} 40%, ${swatchHexes[1]} 40%, ${swatchHexes[1]} 60%, ${swatchHexes[2]} 60%)`;
        }

        $(swatch).find(applyToSelector).css('background', bg);
    });
    }

Shopify.handleize = function(str) {
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

async function checkExclusions() {
  const fetchExclusions = (page = 1, allProductIds = []) => {
    return fetch(`/collections/sitewide-promotion-exclusions/products.json?limit=250&page=${page}`)
      .then(res => res.json())
      .then(data => {
        const productIds = data.products.map(product => product.id);
        allProductIds = allProductIds.concat(productIds);
        if (data.products.length === 250) {
          return fetchExclusions(page + 1, allProductIds);
        }
        window.exclusions = allProductIds;
        return allProductIds;
      });
  };

  return fetchExclusions();
}

async function checkEcommerceExclusives() {
  const fetchEcommerceExclusives = (page = 1, allProductIds = []) => {
    return fetch(`/collections/ecommerce-exclusive/products.json?limit=250&page=${page}`)
      .then(res => res.json())
      .then(data => {
        const productIds = data.products.map(product => product.id);
        allProductIds = allProductIds.concat(productIds);
        if (data.products.length === 250) {
          return fetchEcommerceExclusives(page + 1, allProductIds);
        }
        window.ecommerceExclusives = allProductIds;
        return allProductIds;
      });
  };

  return fetchEcommerceExclusives();
}

document.addEventListener("DOMContentLoaded", function() {
    var lazyloadImages;    
  
    if ("IntersectionObserver" in window) {
      lazyloadImages = document.querySelectorAll(".lazybg");
      var imageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var image = entry.target;
            image.classList.remove("lazybg");
            imageObserver.unobserve(image);
          }
        });
      });
  
      lazyloadImages.forEach(function(image) {
        imageObserver.observe(image);
      });
    } else {  
      var lazyloadThrottleTimeout;
      lazyloadImages = document.querySelectorAll(".lazybg");
      
      function lazyload () {
        if(lazyloadThrottleTimeout) {
          clearTimeout(lazyloadThrottleTimeout);
        }    
  
        lazyloadThrottleTimeout = setTimeout(function() {
          var scrollTop = window.pageYOffset;
          lazyloadImages.forEach(function(img) {
              if(img.offsetTop < (window.innerHeight + scrollTop)) {
                img.src = img.dataset.src;
                img.classList.remove('lazybg');
              }
          });
          if(lazyloadImages.length == 0) { 
            document.removeEventListener("scroll", lazyload);
            window.removeEventListener("resize", lazyload);
            window.removeEventListener("orientationChange", lazyload);
          }
        }, 20);
      }
  
      document.addEventListener("scroll", lazyload);
      window.addEventListener("resize", lazyload);
      window.addEventListener("orientationChange", lazyload);
    }
    try {
      checkExclusions();
      checkEcommerceExclusives();
    } catch (e) {
      console.error('Error checking exclusions:', e);
    }
  })
  
  